import Vue from 'vue'
import Router from 'vue-router'

const index = () => import('@/pages/index.vue') 
const login = () => import('@/pages/login.vue')
const frame = () => import('@/pages/frame.vue')
const frame2 = () => import('@/pages/frame2.vue')
const mobileEditPlate = () => import('@/pages/editPlate-mobile.vue')
const plate = () => import('@/pages/plate.vue')
const classAlbum = () => import('@/pages/classAlbum.vue')
const claimAlbum = () => import('@/pages/claimAlbum.vue')
const upload = () => import('@/pages/upload.vue')
const studentFrame = () => import('@/pages/studentFrame.vue')
const studentAlbum = () => import('@/pages/studentAlbum.vue')
const pictures = () => import('@/pages/pictures')
const tools = () => import('@/pages/tools')
const center = () => import('@/pages/center')
const growup = () => import('@/pages/growup')
const editPlate = () => import('@/pages/editPlate')
const test = () => import('@/pages/test')
const classRecord = () => import('@/pages/classRecord.vue')
const classRecordList = () => import('@/pages/classRecordList.vue')
const classAlbumRecord = () => import('@/pages/classAlbumRecord.vue')
const mobileGrowup = () => import('@/pages/mobileGrowup.vue')
const growupRecord = () => import('@/pages/growupRecord.vue')
const news = () => import('@/pages/news.vue')
const mobileGrowupBook = () =>import('@/pages/mobileGrowupBook.vue')
const mobileGrowupBook2 = () =>import('@/pages/pcGrowup.vue')
Vue.use(Router)
const router = new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/login',
        },
        {
            path: '/upload/:id',
            component: upload,
            meta: {
                title: '上传协助',
                keepAlive: false,
                tabIndex:0
            }
        },
        {
            path: '/login', 
            component: login,
            meta: {
                title: '登录',
                keepAlive: false
            }
        },
        {
            path: '/editPlate/:c_id',
            component: editPlate,
            meta: {
                title: '成长册编辑',
                keepAlive: false
            }
        },
        {
            path: '/mobileGrowup/:s_id',
            component: mobileGrowup,
            meta: {
                title: '成长册页码',
                keepAlive: true
            }
        },
        // {
        //     path: '/mobileGrowup/:s_id/:guc_id',
        //     component: pcGrowup,
        //     meta: {
        //         title: '成长册页码',
        //         keepAlive: false
        //     }
        // },
        // {
        //     path: '/mobileGrowupBook/:s_id',
        //     component: mobileGrowupBook,
        //     meta: {
        //         title: '成长册页码',
        //         keepAlive: true
        //     }
        // },
        {
            path: '/mobileGrowupBook/:id/:guc_id',
            component: mobileGrowupBook,
            meta: {
                title: '成长册预览',
                keepAlive: false,
                tabIndex:5
            }
        },
        {
            path: '/mobileGrowupList/:sid',
            component: mobileGrowupBook2,
            meta: {
                title: '成长册预览',
                keepAlive: false,
                tabIndex:5
            }
        },
        {
            path: '/mobileEditPlate/:c_id',
            component: mobileEditPlate,
            name:'mobileEditPlate',
            meta: {
                title: '成长册编辑',
                keepAlive: false
            }
        },
        
        {
            path: '/index',
            component: index,
            meta: {
                title: '首页',
                keepAlive: true
            },
            children:[
                {
                    path: '/frame',
                    component: frame,
                    meta: {
                        title: '上传协助',
                        keepAlive: false,
                        tabIndex:0
                    }
                },
                {
                    path: '/frame2',
                    component: frame2,
                    meta: {
                        title: '认领协助',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/news',
                    component: news,
                    meta: {
                        title: '消息中心',
                        keepAlive: false
                    }
                },
                {
                    path: '/plate',
                    component: plate,
                    meta: {
                        title: '成长册编辑',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/growup/:guc_id',
                    component: growup,
                    meta: {
                        title: '成长册预览',
                        keepAlive: false,
                        tabIndex:2
                    }
                },
                {
                    path: '/classAlbum/:id',
                    component: classAlbum,
                    meta: {
                        title: '上传协助',
                        keepAlive: false,
                        tabIndex:0
                    }
                },
                {
                    path: '/claimAlbum/:id',
                    component: claimAlbum,
                    meta: {
                        title: '认领协助',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/upload/:id',
                    component: upload,
                    meta: {
                        title: '班级相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/studentFrame/:id',
                    component: studentFrame,
                    meta: {
                        title: '学生相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/studentAlbum/:studentId',
                    component: studentAlbum,
                    meta: {
                        title: '学生相册',
                        keepAlive: false,
                        tabIndex:1
                    }
                },
                {
                    path: '/pictures',
                    component: pictures,
                    meta: {
                        title: '素材管理',
                        keepAlive: true,
                        tabIndex:3
                    }
                },
                {
                    path: '/tools',
                    component: tools,
                    meta: {
                        title: '常用工具',
                        keepAlive: true,
                        tabIndex:4
                    }
                },
                {
                    path: '/growupRecord/:id/:guc_id',
                    component: growupRecord,
                    meta: {
                        title: '成长册归档',
                        keepAlive: false,
                        tabIndex:5
                    }
                },
                {
                    path: '/classRecord/:index',
                    component: classRecord,
                    meta: {
                        title: '班级归档',
                        keepAlive: false,
                        tabIndex:5
                    }
                },
                {
                    path: '/classRecordList',
                    component: classRecordList,
                    meta: {
                        title: '班级归档',
                        keepAlive: true,
                        tabIndex:5
                    }
                },
                {
                    path: '/classAlbumRecord/:id',
                    component: classAlbumRecord,
                    meta: {
                        title: '班级相册',
                        keepAlive: false,
                        tabIndex:5
                    }
                },
                {
                    path: '/center',
                    component: center,
                    meta: {
                        title: '个人中心',
                        keepAlive: true,
                        tabIndex:null
                    }
                },
                {
                    path: '/test',
                    component: test,
                    meta: {
                        title: '测试工具',
                        keepAlive: true,
                        tabIndex:null
                    }
                }
                
            ]
        }
    ]
})


router.afterEach((to) => {
    document.title = to.meta.title
})
export default router